"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagLink = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _polished = require("polished");

var _styles = require("../shared/styles");

var _Link = require("../Link");

var _TagItem = require("./TagItem");

var TagLink = ( /*#__PURE__*/0, _theming.styled)(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_TagItem.TagItem, (0, _extends2["default"])({}, props, {
    as: _Link.Link
  }), props.isLoading ? 'Loading tag' : props.children); // TODO: check if this explicit type param is needed
}, process.env.NODE_ENV === "production" ? {
  target: "eacevr00"
} : {
  target: "eacevr00",
  label: "TagLink"
})("&:after{content:'';position:absolute;z-index:-1;top:0;left:0;width:100%;height:100%;box-shadow:rgba(0, 0, 0, 0.08) 0 3px 10px 0;opacity:0;transition:opacity 0.3s ease-in-out;}", function (props) {
  return !props.isLoading && /*#__PURE__*/(0, _theming.css)("&:hover{border-color:", (0, _polished.rgba)(_styles.color.secondary, 0.5), ";&:after{opacity:1;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:TagLink;"));
}, ";");
exports.TagLink = TagLink;
TagLink.defaultProps = {
  isLoading: false
};